import { UrlConstants } from "../url.constants";
export class ApiEhInspectionConstants {
    static URL = UrlConstants.API_V2 + "EhInspection";
    static FUNCTION_GET = "GET";
}
